import { graphql } from 'gatsby';
import React from 'react';
import SplitHero from './split-hero';
import FullWidthHero from './full-width-hero';

export interface HeroProps {
    has_location_widget?: boolean
    fullwidth_background?: boolean
    heading?: string
    subheading?: string
    copy?: string
    hero_offset?: unknown
    button_link?: ContentStackLink
    button_link_2?: ContentStackLink
    image?: ContentStackImage
}

const Hero = (props: HeroProps): JSX.Element => {
    const { fullwidth_background } = props;
    if (fullwidth_background) {
        return <FullWidthHero {...props} />;
    }

    return <SplitHero {...props} />;
};
export const query = graphql`
  fragment HeroData on CmsPageBuilderBlocks {
    hero {
      has_location_widget
      fullwidth_background
      heading
      subheading
      copy
      hero_offset
      button_link {
        href
        title
      }
      button_link_2 {
        href
        title
      }
      image {
        filename
        title
        description
        url
        contentStackAsset(width: 1920)
      }
    }
  }
`;

export default Hero;
